import * as THREE from 'three'

export type Pose = { delta: THREE.Vector3; quat: THREE.Quaternion }

export function identityPose(): Pose {
  return { delta: new THREE.Vector3(), quat: new THREE.Quaternion() }
}

export function clonePose(p: Pose): Pose {
  return { delta: p.delta.clone(), quat: p.quat.clone() }
}

export function posesEqual(a: Pose, b: Pose): boolean {
  if (a === b) return true
  return a.delta.distanceToSquared(b.delta) < 1e-12 && Math.abs(a.quat.dot(b.quat)) > 1 - 1e-9
}

export function isIdentityPose(p: Pose): boolean {
  return p.delta.lengthSq() < 1e-12 && Math.abs(p.quat.w) > 1 - 1e-9
}

export function easeInOut(t: number): number {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
}
